import React, { useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { resetDataBooking, setShowNotif } from "../../store/actions";
import { useHistory, Link } from "react-router-dom";
import {
  MDBContainer,
  MDBRow,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
  MDBNotification,
} from "mdbreact";
import Detail from "../../components/Detail";
import PrimaryButton from "../../components/Button/PrimaryButton";
import SecondaryButton from "../../components/Button/SecondaryButton";
import Loading from "../../components/Loading";
import { useForm } from "react-hook-form";
import Jumbotron from "../../components/Jumbotron";
import axiosPost from "../../helpers/axiosPost";
import Turnstile from "react-cloudflare-turnstile";

export default function Summary() {
  const scroll = useRef(null);
  const executeScroll = () => scroll.current.scrollIntoView();

  const [captchaValue, setCaptchaValue] = useState(null);
  const [showLocalNotif, setShowLocalNotif] = useState(false);
  const [localError, setLocalError] = useState(null);

  const history = useHistory();
  const booking = useSelector((state) => state.bookingStore.dataBooking);
  const summary = useSelector((state) => state.bookingStore.dataSummary);
  const data = { ...booking, ...summary };
  const userCode = sessionStorage.getItem("userCode");
  const userType = useSelector((state) => state.userStore.userType);

  const file = useSelector((state) => state.bookingStore.dataFoto.file);
  const dispatch = useDispatch();

  const { register, handleSubmit, errors, setValue, clearErrors } = useForm({
    defaultValues: {
      agreement: false,
    },
  });

  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);

  const handleTerms = () => {
    setModal(!modal);
  };

  const handleAgree = () => {
    setValue("agreement", true);
    setModal(false);
    clearErrors("agreement");
  };

  const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;
  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const submitHandler = () => {
    executeScroll();

    if (!captchaValue) {
      setShowLocalNotif(true);
      setLocalError({
        message: "Please complete the captcha!",
        statusCode: 401,
      });
      setLoading(false);
      return;
    }

    const fd = new FormData();

    fd.append("userCode", data.insured ? data.insured.value : userCode);
    fd.append(
      "username",
      data.insured ? data.insured.label : userType.username
    );
    fd.append("insuredType", data.insuredType);
    fd.append("insuredIdentifyNumber", data.insuredIdentifyNumber);
    fd.append("insuredName", data.insuredName);
    fd.append("insuredAddress", data.insuredAddress);
    fd.append("insuredBirthPlace", data.insuredBirthPlace);
    fd.append("insuredBirthDate", data.insuredBirthDate);
    fd.append("insuredGender", data.insuredGender);
    fd.append("insuredPhoneNumber", data.insuredPhoneNumber);
    fd.append("insuredEmail", data.insuredEmail);
    fd.append("insuredHeirName", data.insuredHeirName);
    fd.append("policyType", "PA-BASIC");
    fd.append("policyStartDate", data.policyStartDate);
    fd.append("sumInsured", 100000000);
    fd.append("file", file);
    fd.append("province", data.province.value ?? null);
    fd.append("token", captchaValue);

    setLoading(true);

    axiosPost({
      url: "/policy/save",
      data: fd,
      callback: (res) => {
        setLoading(false);
        dispatch(setShowNotif(true));
        dispatch(resetDataBooking(true));
        history.push("/history");
        window.scrollTo(0, 0);
      },
      errorCallback: (res) => {
        setLoading(false);
        if (res.statusCode === 400) {
          console.log(res.message);
        } else {
          console.log(res);
        }
      },
    });
  };

  return (
    <>
      <Jumbotron />
      <section className="create-main-content" ref={scroll}>
        <div className="text-center">
          <h3 className="font-weight-bold">SUMMARY</h3>
          <p className="mb-1">SCHEDULE PERSONAL ACCIDENT CO-PRODUCT</p>
          <hr className="create-divider-primary create-divider-big" />
        </div>

        {loading ? (
          <Loading />
        ) : (
          <>
            <div className="mt-5">
              <p className="mb-1">Detail of Insured</p>
              <hr className="create-divider-primary create-divider-small" />
            </div>

            <Detail data={data} />

            <div className="mt-5">
              <form onSubmit={handleSubmit(submitHandler)}>
                <div className="custom-control custom-checkbox mb-2">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="agreementCheckbox"
                    name="agreement"
                    ref={register({ required: true })}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="agreementCheckbox"
                  >
                    <a
                      href="#modal"
                      onClick={(e) => {
                        e.preventDefault();
                        handleTerms();
                      }}
                      style={{
                        textDecoration: "underline",
                        fontWeight: "normal",
                      }}
                    >
                      I agree to this Microsite Term of Service and Conditions
                    </a>
                  </label>
                  {errors.agreement && (
                    <p className="create-error-message">*You must agree</p>
                  )}
                </div>

                <div className="mt-3">
                  <Turnstile
                    turnstileSiteKey={siteKey}
                    callback={handleCaptchaChange}
                  />
                </div>

                <MDBContainer className="create-button-container">
                  <MDBRow between>
                    <Link to="/booking" onClick={executeScroll}>
                      <SecondaryButton text="Back" />
                    </Link>
                    <PrimaryButton
                      loading={loading}
                      text="Submit"
                      type="submit"
                    />
                  </MDBRow>
                </MDBContainer>
              </form>
            </div>

            <MDBModal
              isOpen={modal}
              toggle={handleTerms}
              centered
              fade={false}
              id="modal"
            >
              <MDBModalHeader toggle={handleTerms}>
                {`Term & Conditions`}
              </MDBModalHeader>
              <MDBModalBody>
                This microsite is developed and powered by PT. Pialang Asuransi
                Provis Mitra Sinergi as a form of collaboration and cooperation
                regarding Personal Accident Insurance of PT Great Eastern
                General Insurance Indonesia. <br />
                <br />
                The information contained in this microsite is for general
                information purpose only, and the data information inputted in
                this microsite is solely used for purchase of such product
                purpose. <br />
                <br />
                As an insurance broker, we make representations of our clients
                however we make no promises and/or warranties of any kind
                herein, express or implied, about the completeness, accuracy,
                reliability, suitability or availability with respect to the
                data information inputted in microsite or the information,
                products, services on this microsite for any purpose. Any
                reliance you place on such information in this microsite is
                therefore strictly at your own risk. <br />
                <br />
                In no event will PT. Pialang Asuransi Provis Mitra Sinergi be
                not liable for any loss or damage including without limitation,
                indirect or consequential loss or damage, or any loss or damage
                whatsoever arising from fail in performing PT Great Eastern
                General Insurance Indonesia obligation and/or commit the
                negligence and/or violates the provisions in accordance with the
                Policy, arising out of, or in connection with, the Personal
                Accident Product itself, as PTGreat Eastern General Insurance
                Indonesia is the product owner.
              </MDBModalBody>
              <MDBModalFooter>
                <PrimaryButton text="I Agree" onClick={handleAgree} />
              </MDBModalFooter>
            </MDBModal>
          </>
        )}
      </section>

      {showLocalNotif && (
        <MDBNotification
          onClick={() => setShowLocalNotif(false)}
          show
          fade
          iconClassName={localError ? "text-danger" : "text-success"}
          title={localError ? "Error" : "Success"}
          message={localError ? localError.message :"Data submitted."}
          style={{
            position: "fixed",
            top: "10px",
            right: "10px",
            zIndex: 9999,
            width: 300,
          }}
        />
      )}
    </>
  );
}
